document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');

  if (menuButton && drawer) {
    const closeDrawer = () => {
      document.body.classList.remove('drawer-open');
      menuButton.setAttribute('aria-expanded', 'false');
    };

    menuButton.addEventListener('click', () => {
      const isOpen = document.body.classList.toggle('drawer-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });

    document.querySelectorAll('[data-menu-close]').forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });
  }

  document.querySelectorAll('[data-bundle-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[data-bundle-message]');
      const variants = [...form.querySelectorAll('[data-variant-id]')]
        .map((input) => Number(input.value))
        .filter(Boolean);

      if (!variants.length) return;

      button.disabled = true;
      message.textContent = 'Adding the collection…';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: variants.map((id) => ({ id, quantity: 1 }))
          })
        });

        if (!response.ok) throw new Error('Unable to add the collection.');
        window.location.href = window.Shopify.routes.root + 'cart';
      } catch (error) {
        message.textContent = error.message;
        button.disabled = false;
      }
    });
  });

  const mobileBar = document.querySelector('[data-mobile-buy-bar]');
  const shopSection = document.querySelector('#shop');
  if (mobileBar && shopSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => mobileBar.classList.toggle('is-hidden', entry.isIntersecting),
      { threshold: 0.08 }
    );
    observer.observe(shopSection);
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const mainImage = document.querySelector('#ProductMainImage');
      if (!mainImage || !thumbnail.dataset.imageSrc) return;

      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.srcset = '';
      mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;

      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        const isActive = item === thumbnail;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
    });
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    const minus = control.querySelector('[data-quantity-minus]');
    const plus = control.querySelector('[data-quantity-plus]');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
